import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import slsMarca from '@/store/SistemaDKP/sls-marca.store';
import hbiExFamComerc from '@/store/SistemaDKP/hbi-ex-fam-comerc.store';
import slsImagemHome from '@/store/SistemaDKP/sls-imagem-home.store';
import slsImagemLogin from '@/store/SistemaDKP/sls-imagem-login.store';
import slsTemplateImagem from '@/store/SistemaDKP/sls-template-imagem.store';
import slsFamiliaComercial from '@/store/SistemaDKP/sls-familia-comercial.store';
import slsEmbalagem from '@/store/SistemaDKP/sls-embalagem.store';
import sisDkpClientes from '@/store/sis-dkp-clientes.store';
import sisDkpClientesTokens from '@/store/sis-dkp-clientes-token.store';
import auth from '@/store/auth.store';
import PTC_PermissaoAcessoClient from '@/store/PTC/PTC_PermissaoAcesso.store';
import PTC_CadastroClienteClient from '@/store/PTC/PTC_CadastroCliente.store';
import PTC_ProdutosClient from '@/store/PTC/PTC_Produto.store';
import PTC_BoletosClient from '@/store/PTC/PTC_Boletos.store';
import PTC_NotasClient from '@/store/PTC/PTC_Notas.store';
import ItemStore from '@/store/item.store';
import PTC_PedidosClient from '@/store/PTC/PTC_Pedidos.store';
import slsCor from '@/store/SistemaDKP/sls-cor.store';
import PTC_Dashboard from '@/store/PTC/PTC_Dashboard.store';
import SLS_PedidosVendas from '@/store/Operacoes/SLS_PedidoVendas.store';
import InfoPedido from '@/store/catalogo-produto/InfoPedido.store';
import SLSUsuarioRepresentante from '@/store/SistemaDKP/sls-usuariorepresentante.store';
import SISUsuarioCliente from '@/store/SistemaDKP/sis_usuario_cliente.store';
import SLSRepresentante from '@/store/SistemaDKP/sls_representante.store';
import SLSTabelapreco from '@/store/SistemaDKP/SLSTabelapreco.store';
import SLSCliente from '@/store/SistemaDKP/sls_cliente.store';
import SLSEsPriori from '@/store/SistemaDKP/sls-es-priori.store';
import SLSClienteEndereco from '@/store/SistemaDKP/sls_cliente_endereco.store';
import SLSCondicaoPagamento from '@/store/SistemaDKP/sls-condicao-pagamento.store';
import SLSGfePrazo from '@/store/SistemaDKP/SLSGfePrazo.store';
import SLSGfePrazoService from '@/services/SistemaDKP/SLSGfePrazo.service';
import ECommercerStore from '@/store/cart.store';
import intensPedido from '@/store/Operacoes/itensPedido.store';
import PedidosStore from '@/store/pedidos.store';
import PicStore from '@/store/pic.store';

import filesStore from '@/store/Operacoes/filesPedido.store';
import BoletoStore from '@/store/Operacoes/boleto.store';
import comissoesStore from '@/store/relatorios/comissoes.store';
import verticalMenu from './vertical-menu';
import app from './app';
import appConfig from './app-config';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    slsImagemHome,
    slsImagemLogin,
    verticalMenu,
    slsMarca,
    hbiExFamComerc,
    slsTemplateImagem,
    slsFamiliaComercial,
    sisDkpClientes,
    sisDkpClientesTokens,
    auth,
    PTC_PermissaoAcessoClient,
    PTC_CadastroClienteClient,
    PTC_ProdutosClient,
    PTC_BoletosClient,
    slsEmbalagem,
    PTC_NotasClient,
    ItemStore,
    PTC_PedidosClient,
    slsCor,
    PTC_Dashboard,
    InfoPedido,
    SLSUsuarioRepresentante,
    SISUsuarioCliente,
    SLS_PedidosVendas,
    SLSRepresentante,
    SLSCliente,
    SLSEsPriori,
    SLSClienteEndereco,
    SLSTabelapreco,
    SLSCondicaoPagamento,
    SLSGfePrazo,
    intensPedido,
    ECommercerStore,
    PedidosStore,
    PicStore,
    filesStore,
    BoletoStore,
    comissoesStore,
  },
  strict: process.env.DEV,
});
